/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect, useRef} from 'react';
import {useStore} from '../../../../store/store';
import {observer} from 'mobx-react';
import PageWrapper from '../../../modules/PageWrapper';
import Filters from '../../../table/salesLTC/filters/Filters';
import Presets from '../../../table/salesLTC/Presets';
import {getFilters} from './getFilters';
import {filtersAll, filtersTeamlead, filtersManager} from './filtersConfigs';
import {groupsAll, groupsTeamleader, groupsManager} from './groupsConfigs';
import TableWrapper from '../../../table/salesLTC/TableWrapper';
import Columns from '../../../table/salesLTC/Columns';
import {baseFields} from '../../../table/salesLTC/customizationTable';
import BlankSheet from '../../../table/salesLTC/BlankSheet';
import FullScreen from '../../../table/salesLTC/FullScreen';
import Refresh from '../../../table/salesLTC/Refresh';
import ResultsCount from '../../../table/salesLTC/ResultsCount';
import Navigation from '../../../modules/NavigationBloggers';

const Statistics = () => {
  const store = useStore();
  const [prevTimeConfig, setPrevTimeConfig] = useState(null);
  const [editItemId, setEditItemId] = useState(null);

  const getListFilters = () => {
    if (store.roles.includes(8) || store.roles.includes(30)) {
      return filtersTeamlead;
    }
    if (store.roles.includes(16) || store.roles.includes(17) || store.roles.includes(40)) {
      return filtersTeamlead;
    }
    if (store.roles.includes(9) || store.roles.includes(15)) {
      return filtersManager;
    }

    if (
      store.roles.includes(39) ||
      store.roles.includes(32) ||
      store.roles.includes(13) ||
      store.roles.includes(38) ||
      store.roles.includes(4)
    ) {
      return filtersAll;
    }

    return [];
  };

  const getListGroups = () => {
    if (store.roles.includes(8) || store.roles.includes(30)) {
      return groupsTeamleader;
    }
    if (store.roles.includes(16) || store.roles.includes(17) || store.roles.includes(40)) {
      return groupsTeamleader;
    }
    if (store.roles.includes(9) || store.roles.includes(15)) {
      return groupsManager;
    }

    if (
      store.roles.includes(39) ||
      store.roles.includes(32) ||
      store.roles.includes(13) ||
      store.roles.includes(38) ||
      store.roles.includes(4)
    ) {
      return groupsAll;
    }

    return [];
  };

  return (
    <PageWrapper
      firstTimeConfig='current_week'
      prevTimeConfig={prevTimeConfig}
      breadcrumbs={[
        {title: 'Отдел продаж'},
        {isSeparator: true},
        {
          title: 'Статистика LTC',
          path: '/salesLTC/ltc/statistics',
          isActive: true,
        },
      ]}
      title='Статистика LTC'
    >
      <TableWrapper
        setPrevTimeConfig={setPrevTimeConfig}
        prevTimeConfig={prevTimeConfig}
        getMethod={'sales/ltc/statistics'}
        getFilters={getFilters}
        setEditItemId={setEditItemId}
        edit={null}
        defaultFilters={[{filter: 'state', isFixed: false, options: ['with_data']}]}
        defaultGroups={
          store.roles.includes(9)
            ? []
            : [
                {group: 'manager', isFixed: false},
                // {group: 'pixel', isFixed: false},
              ]
        }
        //на випадок якщо нам взагалі не потрібно показувати вибір груп
        hasHiddenGroups={false}
        baseFields={baseFields}
        disabledByDefault={[
          'chats_avg_time',
          'chats_median_time',
          'chat2fd',
          'registration_median_time',
          'reg2fd',
          'first_deposit',
        ]}
      >
        <Filters
          facebookStatisticsFilters={getListFilters()}
          facebookStatisticsGroups={getListGroups()}
          childrenRefresh={false}
          childrenHead={null}
          childrenPresets={
            <>
              <ResultsCount />
              <BlankSheet />
              <Columns columns={baseFields} />
              <Presets />
              <FullScreen />
            </>
          }
          childrenByFilters={<Refresh />}
        />
      </TableWrapper>
    </PageWrapper>
  );
};

export default observer(Statistics);
